namespace TabAurous.SalesOrder {
    export namespace SalesOrderItemsService {
        export const baseUrl = 'SalesOrder/SalesOrderItems';

        export declare function Create(request: Serenity.SaveRequest<SalesOrderItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SalesOrderItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SalesOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ValidateQuotation(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "SalesOrder/SalesOrderItems/Create",
            Update = "SalesOrder/SalesOrderItems/Update",
            Delete = "SalesOrder/SalesOrderItems/Delete",
            Retrieve = "SalesOrder/SalesOrderItems/Retrieve",
            List = "SalesOrder/SalesOrderItems/List",
            CustomList = "SalesOrder/SalesOrderItems/CustomList",
            ValidateQuotation = "SalesOrder/SalesOrderItems/ValidateQuotation"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'ValidateQuotation'
        ].forEach(x => {
            (<any>SalesOrderItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
